import {
  STATE_TRANSITION_IN,
  STATE_TRANSITION_OUT,
  TRANSITION_IN,
  TRANSITION_OUT,
} from "../constants/AnimationConstants";
import AppConstants from "../constants/AppConstants";
import { ANIMATION_TYPE } from "../constants/MergeConstants";

const {
  BG_PROPERTY_MEDIA_TYPE,
  BG_PROPERTY_FILL_TYPE,
  BG_PROPERTY_BG_COLOR,
  BG_TYPE_NONE,
  BG_TYPE_COLOR,
} = AppConstants;

const Block = {
  id: "",
  type: "block",
  name: "New Canvas",
  slug: "new-canvas",
  elements: [],
  states: [],
  visible: "a",
  mobile: {
    w: 320,
    h: 200,
  },
  desktop: {
    w: 1200,
    h: 400,
    [BG_PROPERTY_MEDIA_TYPE]: BG_TYPE_NONE,
    [BG_PROPERTY_FILL_TYPE]: BG_TYPE_COLOR,
    [BG_PROPERTY_BG_COLOR]: "#FFFFFF",
  },
  sync: [
    BG_PROPERTY_FILL_TYPE,
    BG_PROPERTY_MEDIA_TYPE,
    `${STATE_TRANSITION_IN}.${ANIMATION_TYPE}`,
    `${STATE_TRANSITION_OUT}.${ANIMATION_TYPE}`,
    `${TRANSITION_IN}.${ANIMATION_TYPE}`,
    `${TRANSITION_OUT}.${ANIMATION_TYPE}`,
  ],
};

export default Block;
